import { useHistory, useParams } from "react-router-dom";
import CabecalhoDemanda from "../../components/Demanda/CabecalhoDemanda";
import { Container, CabecaFixa } from "./styles";
import { useAuth } from "../../contexts/UserContext";
import AbasDemanda from "../../components/Demanda/AbasDemanda";
import { useEffect, useState, useCallback, useRef } from "react";
import AbaPrincipal from "../../components/Demanda/AbaPrincipal";
import AbaOrientacoes from "../../components/Demanda/AbaOrientacoes";
import AbaPendencias from "../../components/Demanda/AbaPendencias";
import AbaComentarios from "../../components/Demanda/AbaComentarios";
import AbaAnexos from "../../components/Demanda/AbaAnexos";
import AbaHistorico from "../../components/Demanda/AbaHistorico";
import api from "../../services/api";
import { IProposta } from "../../utility/IProposta";
import { contarOrientacoes } from "../../utility/contarOrientacoes";
import { extrairOrientacoes } from "../../components/Demanda/AbaOrientacoes/utils";
import { comentarioService } from "../../services/comentarioService";
import { useSidebarFiltros } from "../../contexts/SidebarFiltrosContext";
import { getFusoHorarioPorComarca } from "../../utility/timezoneUtils";
import { Toaster } from "react-hot-toast";
import toast from 'react-hot-toast';
import { toastDefsError, toastDefs } from '../../config/toastConfig';
import { sanitizeErrorMessage } from '../../utils/errorSanitizer';
import { STATUS_MESSAGES } from '../../utility/statusMessages';
import ModalDefault from "../../components/ModalDefault";
import ProfessionalOrientations from "../OrientationsProfessional";
import ButtonDefault from "../../components/form/ButtonDefault";
import { IconClose } from "../../components/icons";
import { ModalWrapper, ModalTitle, ModalButtons } from "./styles";
import ModalRecusarDemanda from "../../components/Demanda/ModalRecusarDemanda";
import ModalEntregarDemanda from "../../components/Demanda/ModalEntregarDemanda";
import ModalConcluirDemanda from "../../components/Demanda/ModalConcluirDemanda";
import ModalInterromperDemanda from "../../components/Demanda/ModalInterromperDemanda";
import ModalFinalizarDemanda from "../../components/Demanda/ModalFinalizarDemanda";
import ModalReabrirExecucao from "../../components/Demanda/ModalReabrirExecucao";
import ModalCancelarDemanda from "../../components/Demanda/ModalCancelarDemanda";
import ModalDefinirPrazoAceite from "../../components/ModalDefinirPrazoAceite";

export default function Demanda() {
    const { setPageType, user } = useAuth();
    const history = useHistory();
    const params = useParams<any>();
    const id: number = params.id;
    const aba: string = params.aba;
    const [abaAtiva, setAbaAtiva] = useState(aba || 'principal');
    const [demanda, setDemanda] = useState<IProposta | null>(null);
    const [nAnexos, setNAnexos] = useState<number>(0);
    const [nOrientacoes, setNOrientacoes] = useState<number>(0);
    const [nPendencias, setNPendencias] = useState<number>(0);
    const [nComentarios, setNComentarios] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<boolean>(false);
    const [acessoNegado, setAcessoNegado] = useState<boolean>(false);
    const [modalOrientations, setModalOrientations] = useState(false);
    const [startTriagemModal, setStartTriagemModal] = useState(false);
    const [encaminharContratacaoModal, setEncaminharContratacaoModal] = useState(false);
    const [acceptDemandModal, setAcceptDemandModal] = useState(false);
    const [refuseDemandModal, setRefuseDemandModal] = useState(false);
    const [isRefusing, setIsRefusing] = useState(false);
    const [startExecucaoModal, setStartExecucaoModal] = useState(false);
    const [entregarModal, setEntregarModal] = useState(false);
    const [concluirModal, setConcluirModal] = useState(false);
    const [interromperModal, setInterromperModal] = useState(false);
    const [finishDemandModal, setFinishDemandModal] = useState(false);
    const [reabrirExecucaoModal, setReabrirExecucaoModal] = useState(false);
    const [cancelarDemandaModal, setCancelarDemandaModal] = useState(false);
    const [modalPrazoAceiteOpen, setModalPrazoAceiteOpen] = useState(false);
    const [highlightedFileId, setHighlightedFileId] = useState<number | null>(null);
    const [isEditing, setIsEditing] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [hasErrors, setHasErrors] = useState(false);
    const iniciarEdicaoRef = useRef<(() => void) | null>(null);
    const cancelarEdicaoRef = useRef<(() => void) | null>(null);
    const salvarEdicaoRef = useRef<(() => void) | null>(null);
    const hasChangesRef = useRef<(() => boolean) | null>(null);
    const isValidatingRef = useRef<(() => boolean) | null>(null);
    const isSavingRef = useRef<(() => boolean) | null>(null);
    const hasErrorsRef = useRef<(() => boolean) | null>(null);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const { setSidebarFiltrosOpen } = useSidebarFiltros();

    const fecharOrientacoes = useCallback(() => {
        setModalOrientations(false);
        history.push('/demandas');
    }, [history]);

    const carregaContadorAnexos = useCallback(async (quantidadeFallback?: number) => {
        if (!id) return;

        try {
            const response = await api.get(`proposta/${id}/anexos`);

            if (response.data.status === 'success' && Array.isArray(response.data.result)) {
                setNAnexos(response.data.result.length);
                return;
            }
        } catch (error: any) {
            console.error('Erro ao carregar total de anexos:', error);
        }

        if (typeof quantidadeFallback === 'number') {
            setNAnexos(quantidadeFallback);
        }
    }, [id]);

    useEffect(() => {
        if (aba === undefined || aba === null) {
            history.replace(`/demandas/${id}/principal`);
        }
    }, [aba, id, history]);

    const atualizaDemandaSilenciosa = useCallback(async () => {
        if (!id) return;

        try {
            const response = await api.get(`proposta/${id}`);

            if (response.data.status === 'success') {
                const d_demanda = response.data.result;
                setDemanda(d_demanda);
                await carregaContadorAnexos(d_demanda.arquivos.length);
            }
        } catch (error: any) {
            console.error('Erro ao atualizar demanda silenciosamente:', error);
        }
    }, [id, carregaContadorAnexos]);

    const carregaDemanda = useCallback(async () => {
        setLoading(true);
        setError(false);
        setAcessoNegado(false);

        try {
            const response = await api.get(`proposta/${id}`);

            if (response.data.status !== 'success') {
                setLoading(false);
                const errorMessage = response.data.message || '';
                if (errorMessage.toLowerCase().includes('acesso não autorizado') ||
                    errorMessage.toLowerCase().includes('acesso nao autorizado') ||
                    errorMessage.toLowerCase().includes('não autorizado') ||
                    errorMessage.toLowerCase().includes('nao autorizado')) {
                    setAcessoNegado(true);
                } else {
                    setError(true);
                }
                throw new Error(errorMessage);
            }

            const d_demanda = response.data.result;

            try {
                const responseHistory = await api.get(`historico-proposta/${id}`);
                if (responseHistory.data.status === 'success') {
                    d_demanda.historico = responseHistory.data.result || [];
                }
            } catch (e) {
                d_demanda.historico = [];
            }

            setDemanda(d_demanda);
            await carregaContadorAnexos(d_demanda.arquivos.length);
            setError(false);
            setAcessoNegado(false);

            if (user && user.profile === 'comum' &&
                (d_demanda.substatus_orientacao === 'Aguardando Ciência' ||
                    d_demanda.status_orientacao === 'Aguardando Ciência')) {
                const listaOrientacoes = Array.isArray(d_demanda.orientacoes) ? d_demanda.orientacoes : [];
                const { orientacoesCompletas } = extrairOrientacoes(listaOrientacoes);
                
                if (orientacoesCompletas.length > 0) {
                    setModalOrientations(true);
                }
            }

            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            const errorMessage = error?.message || error?.response?.data?.message || '';
            if (errorMessage.toLowerCase().includes('acesso não autorizado') ||
                errorMessage.toLowerCase().includes('acesso nao autorizado') ||
                errorMessage.toLowerCase().includes('não autorizado') ||
                errorMessage.toLowerCase().includes('nao autorizado') ||
                error?.response?.status === 401 ||
                error?.response?.status === 403) {
                setAcessoNegado(true);
                setError(false); // Não mostrar erro quando for acesso negado
            } else {
                setError(true);
                setAcessoNegado(false);
            }
            console.error('Erro ao carregar demanda:', error);
        }
    }, [id, user, carregaContadorAnexos]);

    useEffect(() => {
        setPageType('vazio');
        setSidebarFiltrosOpen(false);
    }, [setPageType, setSidebarFiltrosOpen]);

    useEffect(() => {
        let isMounted = true;
        const loadDemand = async () => {
            try {
                await carregaDemanda();
            } catch (error) {
                if (isMounted) {
                    console.error('Erro ao carregar demanda:', error);
                }
            }
        };
        if (isMounted) {
            loadDemand();
        }
        return () => {
            isMounted = false;
        };
    }, [id, carregaDemanda]);

    const handleRetry = useCallback(() => {
        carregaDemanda();
    }, [carregaDemanda]);

    useEffect(() => {
        setNOrientacoes(contarOrientacoes(demanda, user));
    }, [demanda, user]);

    const carregaContadoresPendencias = useCallback(async () => {
        if (!id || !user) return;

        try {
            const response = await api.get(`pendencias/kanban/${id}`);

            if (response.data.status === 'success' && Array.isArray(response.data.result)) {
                // Aplicar o mesmo filtro usado no Kanban: cada perfil só vê suas próprias pendências
                const pendenciasFiltradas = response.data.result.filter((pendencia: any) => {
                    const userProfile = user?.profile;
                    const destinoNormalizado = String(pendencia.destino || '').toLowerCase().trim();
                    
                    // Profissional (comum) não deve ver pendências direcionadas ao solicitante
                    if (userProfile === 'comum') {
                        if (destinoNormalizado === 'solicitante') {
                            return false;
                        }
                    }
                    
                    // Solicitante não deve ver pendências direcionadas ao profissional
                    if (userProfile === 'Solicitante' || userProfile === 'solicitante') {
                        if (destinoNormalizado === 'profissional') {
                            return false;
                        }
                    }
                    
                    return true;
                });
                
                setNPendencias(pendenciasFiltradas.length);
            } else {
                setNPendencias(0);
            }
        } catch (error: any) {
            console.error('Erro ao carregar total de pendências:', error);
            setNPendencias(0);
        }
    }, [id, user]);

    const carregaContadorComentarios = useCallback(async () => {
        if (!id) return;

        try {
            const contador = await comentarioService.getContador(id);
            setNComentarios(contador);
        } catch (error: any) {
            console.error('Erro ao carregar contador de comentários:', error);
            setNComentarios(0);
        }
    }, [id]);

    useEffect(() => {
        if (aba && aba !== abaAtiva) {
            setAbaAtiva(aba);
        }
    }, [aba, abaAtiva]);

    useEffect(() => {
        carregaContadoresPendencias();
    }, [carregaContadoresPendencias]);

    useEffect(() => {
        carregaContadorComentarios();
    }, [carregaContadorComentarios]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleNavigateToFile = async (fileId: number) => {
        try {
            const resposta = await api.get(`proposta/${id}/anexos`);
            const anexo = resposta.data?.result?.find(
                (a: any) => a.id_proposta_arquivo === fileId
            );

            if (!anexo || anexo.excluido) {
                toast.error('Este arquivo foi removido e não está mais disponível.');
                return;
            }
        } catch (erro) {
            toast.error('Não foi possível verificar o anexo agora. Tente novamente.');
            return;
        }

        setAbaAtiva('anexos');
        history.replace(`/demandas/${id}/anexos`);
        setHighlightedFileId(fileId);

        setTimeout(() => {
            setHighlightedFileId(null);
        }, 3000);
    };

    async function startTriagem() {
        try {
            if (loading) {
                return;
            }

            setLoading(true);
            const response = await api.put(`proposta/${id}/iniciar-triagem`);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao iniciar triagem');
            }

            toast.success(STATUS_MESSAGES.TRIAGEM_INICIADA, toastDefs);
            setStartTriagemModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_TRIAGEM);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    function handleEncaminharContratacaoClick() {
        if (!demanda) {
            toast.error('Erro ao carregar dados da demanda', toastDefsError);
            return;
        }

        if (!demanda.prazo_aceite) {
            setModalPrazoAceiteOpen(true);
            return;
        }

        setEncaminharContratacaoModal(true);
    }

    async function confirmarPrazoAceite(prazoAceiteISO: string) {
        try {
            if (loading || !demanda) {
                return;
            }

            setLoading(true);

            const formatarDataParaAPI = (data: any): string => {
                if (!data) return '';
                if (typeof data === 'string') {
                    if (data.includes('T')) {
                        return data.replace('T', ' ').replace(/\.\d{3}Z?$/, '').substring(0, 19);
                    }
                    return data;
                }
                if (data instanceof Date) {
                    const year = data.getFullYear();
                    const month = String(data.getMonth() + 1).padStart(2, '0');
                    const day = String(data.getDate()).padStart(2, '0');
                    const hours = String(data.getHours()).padStart(2, '0');
                    const minutes = String(data.getMinutes()).padStart(2, '0');
                    const seconds = String(data.getSeconds()).padStart(2, '0');
                    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
                }
                return '';
            };

            const prazoAceiteFormatado = formatarDataParaAPI(prazoAceiteISO);

            const propostaAtualizada = {
                id_usuario: demanda.id_usuario || 0,
                id_servico: demanda.id_servico,
                id_comarca: demanda.id_comarca,
                numero_processo: demanda.numero_processo || '',
                nome_cliente: demanda.nome_cliente || '',
                valor_cliente: demanda.valor_cliente || '0.00',
                codigo_cliente: demanda.codigo_cliente || '',
                prazo_aceite: prazoAceiteFormatado,
                prazo_para_conclusao: formatarDataParaAPI(demanda.prazo_para_conclusao),
                dias_uteis_para_conclusao: demanda.dias_uteis_para_conclusao || '',
                tipo_audiencia: demanda.tipo_audiencia || '',
                data: formatarDataParaAPI(demanda.data),
                profissional_necessario: demanda.profissional_necessario || '',
                modalidade: demanda.modalidade || '',
                endereco_virtual: demanda.endereco_virtual || '',
                rua: demanda.rua || '',
                bairro: demanda.bairro || '',
                cep: demanda.cep || '',
                numero: demanda.numero || '',
                complemento: demanda.complemento || '',
                valor_profissional: demanda.valor_profissional || '0.00',
                tipo: demanda.tipo || 'proposta',
                status: demanda.status || 'Em Triagem',
                natureza: demanda.natureza || '',
                data_tz: demanda.data_tz || ''
            };

            const response = await api.put(`proposta/${id}`, propostaAtualizada);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao definir prazo de aceite');
            }

            toast.success('Prazo de aceite definido com sucesso', toastDefs);
            setModalPrazoAceiteOpen(false);
            await carregaDemanda();
            
            setEncaminharContratacaoModal(true);
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || 'Erro ao definir prazo de aceite');
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function encaminharParaContratacao() {
        try {
            if (loading) {
                return;
            }

            setLoading(true);

            const response = await api.put(`proposta/${id}/encaminhar-para-contratacao`);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao encaminhar para contratação');
            }

            toast.success(STATUS_MESSAGES.ENCAMINHADA_CONTRATACAO, toastDefs);
            setEncaminharContratacaoModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_ENCAMINHAR);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function aceitarDemanda() {
        try {
            if (loading) {
                return;
            }

            setLoading(true);
            const response = await api.put(`proposta-responder/${id}?aceitar=true`);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao aceitar demanda');
            }

            toast.success(STATUS_MESSAGES.DEMANDA_ACEITA, toastDefs);
            setAcceptDemandModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_ACEITAR);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function recusarDemanda(justificativa: string) {
        try {
            if (isRefusing) {
                return;
            }

            if (!justificativa || !justificativa.trim()) {
                toast.error('A justificativa é obrigatória', toastDefsError);
                return;
            }

            setIsRefusing(true);
            const response = await api.put(`proposta-responder/${id}?aceitar=false`, {
                justificativa: justificativa.trim()
            });

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao recusar demanda');
            }

            toast.success(STATUS_MESSAGES.DEMANDA_RECUSADA, toastDefs);
            setRefuseDemandModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_RECUSAR);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setIsRefusing(false);
        }
    }

    function handleIniciarExecucaoClick() {
        if (!demanda) {
            toast.error('Erro ao carregar dados da demanda', toastDefsError);
            return;
        }

        setStartExecucaoModal(true);
    }

    async function handleDuplicarClick() {
        if (loading || !demanda) return;

        try {
            setLoading(true);
            const response = await api.delete(`proposta-reaproveitar/${id}`);

            if (response.data.status !== 'success' || !response.data.result) {
                throw new Error(response.data.message || 'Erro ao duplicar demanda');
            }

            history.push({
                pathname: '/Nova-Demanda',
                state: {
                    name: 'Reuse',
                    proposal: response.data.result,
                    idPropostaOriginal: demanda.id_proposta
                }
            });
        } catch (error: any) {
            toast.error(sanitizeErrorMessage(error?.message || 'Erro ao duplicar demanda'), toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function iniciarExecucao() {
        try {
            if (loading) {
                return;
            }

            setLoading(true);
            const response = await api.put(`proposta/${id}/iniciar-execucao`);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao iniciar execução');
            }

            toast.success(STATUS_MESSAGES.EXECUCAO_INICIADA, toastDefs);
            setStartExecucaoModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_INICIAR_EXECUCAO);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    function handleEntregarClick() {
        setEntregarModal(true);
    }

    function handleEscolherConcluir() {
        setEntregarModal(false);
        setConcluirModal(true);
    }

    function handleEscolherInterromper() {
        setEntregarModal(false);
        setInterromperModal(true);
    }

    async function concluirDemanda(observacoes: string, arquivosIds: number[]) {
        try {
            if (loading) {
                return;
            }

            setLoading(true);

            const payload = {
                justificativa: observacoes || '',
                arquivosIds: arquivosIds || []
            };

            const response = await api.put(`proposta-concluirinterromper/${id}?status=Concluida`, payload);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao concluir demanda');
            }

            toast.success(STATUS_MESSAGES.DEMANDA_CONCLUIDA, toastDefs);
            setConcluirModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_CONCLUIR);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function interromperDemanda(motivo: string, arquivosIds: number[]) {
        try {
            if (loading) {
                return;
            }

            if (!motivo || !motivo.trim()) {
                toast.error('O motivo da interrupção é obrigatório', toastDefsError);
                return;
            }

            setLoading(true);

            const payload = {
                justificativa: motivo.trim(),
                arquivosIds: arquivosIds || []
            };

            const response = await api.put(`proposta-concluirinterromper/${id}?status=Interrompida`, payload);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao interromper demanda');
            }

            toast.success(STATUS_MESSAGES.DEMANDA_INTERROMPIDA, toastDefs);
            setInterromperModal(false);
            await new Promise(resolve => setTimeout(resolve, 500));
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_INTERROMPER);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function finalizarDemanda(statusFinalizacao: 'Aceita' | 'Recusada', justificativa: string) {
        try {
            if (loading) {
                return;
            }

            const justificativaTratada = justificativa.trim();
            if (!justificativaTratada) {
                toast.error('Descreva o resultado da demanda', toastDefsError);
                return;
            }

            setLoading(true);

            const payload = {
                status_finalizacao: statusFinalizacao,
                justificativa: justificativaTratada
            };

            const response = await api.put(`proposta-finalizar/${id}`, payload);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao finalizar demanda');
            }

            toast.success(STATUS_MESSAGES.DEMANDA_FINALIZADA, toastDefs);
            setFinishDemandModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_FINALIZAR);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function reabrirExecucao() {
        try {
            if (loading) {
                return;
            }

            setLoading(true);

            const response = await api.put(`proposta/${id}/reabrir-execucao`, {});

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao reabrir execução');
            }

            toast.success(STATUS_MESSAGES.EXECUCAO_REABERTA, toastDefs);
            setReabrirExecucaoModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_REABRIR);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function cancelarDemanda(justificativa: string) {
        try {
            if (loading) {
                return;
            }

            if (!justificativa || !justificativa.trim()) {
                toast.error('O motivo do cancelamento é obrigatório', toastDefsError);
                return;
            }

            setLoading(true);

            const justificativaEncoded = encodeURIComponent(justificativa.trim());
            const response = await api.delete(`proposta/${id}?justificativa=${justificativaEncoded}`);

            if (response.data.status !== 'success') {
                throw new Error(response.data.result?.[0]?.message || response.data.message || 'Erro ao cancelar demanda');
            }

            toast.success(STATUS_MESSAGES.DEMANDA_CANCELADA, toastDefs);
            setCancelarDemandaModal(false);
            await carregaDemanda();
            await carregaContadoresPendencias();
            await carregaContadorComentarios();
        } catch (error: any) {
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || STATUS_MESSAGES.ERRO_CANCELAR);
            toast.error(userFriendlyMessage, toastDefsError);
        } finally {
            setLoading(false);
        }
    }

    async function acceptOrientation() {
        if (!demanda) return;

        const orientacoes = (demanda as any).orientacoes;
        if (!orientacoes || !Array.isArray(orientacoes) || orientacoes.length === 0) {
            return;
        }

        try {
            if (orientacoes.length === 1) {
                const orientacao = orientacoes[0];
                if (!orientacao || typeof orientacao !== 'object' || !orientacao.id_orientacao) {
                    throw new Error('Orientação inválida');
                }

                const id_orientation = orientacao.id_orientacao;

                const response = await api.put('orientacao-aceitar/' + id_orientation);

                if (response.data.status !== 'success') {
                    if (response.data.result[0] === undefined) {
                        throw new Error(response.data.message);
                    } else {
                        throw new Error(response.data.result[0].message);
                    }
                }

                await carregaDemanda();
            } else {
                const orientacao = orientacoes[1];
                if (!orientacao || typeof orientacao !== 'object' || !orientacao.id_orientacao) {
                    throw new Error('Orientação inválida');
                }

                const id_orientation = orientacao.id_orientacao;

                const response = await api.put('orientacao-aceitar/' + id_orientation);

                if (response.data.status !== 'success') {
                    if (response.data.result[0] === undefined) {
                        throw new Error(response.data.message);
                    } else {
                        throw new Error(response.data.result[0].message);
                    }
                }

                await carregaDemanda();
            }
        } catch (error: any) {
            console.error('Erro ao aceitar orientação:', error);
            const userFriendlyMessage = sanitizeErrorMessage(error?.message || 'Erro ao aceitar orientação');
            toast.error(userFriendlyMessage, toastDefsError);
        }
    }

    const handleEditClick = useCallback(() => {
        if (abaAtiva !== 'principal') {
            setAbaAtiva('principal');
            history.replace(`/demandas/${id}/principal`);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                if (iniciarEdicaoRef.current) {
                    iniciarEdicaoRef.current();
                }
            }, 100);
        } else {
            if (iniciarEdicaoRef.current) {
                iniciarEdicaoRef.current();
            }
        }
    }, [abaAtiva, id, history]);

    const handleEditModeChange = (editing: boolean) => {
        setIsEditing(editing);
        if (!editing) {
            setHasChanges(false);
        }
    };

    const handleCancelarEdicao = useCallback(() => {
        if (cancelarEdicaoRef.current) {
            cancelarEdicaoRef.current();
        }
    }, []);

    const handleSalvarEdicao = useCallback(() => {
        if (salvarEdicaoRef.current) {
            salvarEdicaoRef.current();
        }
    }, []);

    useEffect(() => {
        if (isEditing && hasChangesRef.current) {
            const checkChanges = () => {
                const hasChangesValue = hasChangesRef.current ? hasChangesRef.current() : false;
                setHasChanges(hasChangesValue);
                const isValidatingValue = isValidatingRef.current ? isValidatingRef.current() : false;
                setIsValidating(isValidatingValue);
                const isSavingValue = isSavingRef.current ? isSavingRef.current() : false;
                setIsSaving(isSavingValue);
                const hasErrorsValue = hasErrorsRef.current ? hasErrorsRef.current() : false;
                setHasErrors(hasErrorsValue);
            };
            checkChanges();
            const interval = setInterval(checkChanges, 300);
            return () => clearInterval(interval);
        } else {
            setHasChanges(false);
            setIsValidating(false);
            setIsSaving(false);
            setHasErrors(false);
        }
    }, [isEditing]);

    return (
        <Container>
            <CabecaFixa>
                <CabecalhoDemanda
                    demanda={demanda || undefined}
                    loading={loading}
                    acessoNegado={acessoNegado}
                    onEditClick={handleEditClick}
                    isEditing={isEditing}
                    onCancelarEdicao={handleCancelarEdicao}
                    onSalvarEdicao={handleSalvarEdicao}
                    hasChanges={hasChanges}
                    isValidating={isValidating || isSaving}
                    hasErrors={hasErrors}
                    onStartTriagemClick={() => setStartTriagemModal(true)}
                    onEncaminharContratacaoClick={handleEncaminharContratacaoClick}
                    onAceitarDemandaClick={() => setAcceptDemandModal(true)}
                    onRecusarDemandaClick={() => setRefuseDemandModal(true)}
                    onIniciarExecucaoClick={handleIniciarExecucaoClick}
                    onEntregarClick={() => setEntregarModal(true)}
                    onFinalizarClick={() => setFinishDemandModal(true)}
                    onReabrirExecucaoClick={() => setReabrirExecucaoModal(true)}
                    onCancelarClick={() => setCancelarDemandaModal(true)}
                    onDuplicarClick={handleDuplicarClick}
                />
                <AbasDemanda
                    id={id}
                    abaAtiva={abaAtiva}
                    loading={loading}
                    anexos={nAnexos}
                    orientacoes={nOrientacoes}
                    pendencias={nPendencias}
                    comentarios={nComentarios}
                />
            </CabecaFixa>

            <AbaPrincipal
                abaAtiva={abaAtiva}
                demanda={demanda}
                loading={loading}
                error={error}
                acessoNegado={acessoNegado}
                onRetry={handleRetry}
                onEditModeChange={handleEditModeChange}
                onIniciarEdicaoRef={(fn) => { iniciarEdicaoRef.current = fn; }}
                onCancelarEdicaoRef={(fn) => { cancelarEdicaoRef.current = fn; }}
                onSalvarEdicaoRef={(fn) => { salvarEdicaoRef.current = fn; }}
                onHasChangesRef={(fn) => { hasChangesRef.current = fn; }}
                onIsValidatingRef={(fn) => { isValidatingRef.current = fn; }}
                onIsSavingRef={(fn) => { isSavingRef.current = fn; }}
                onHasErrorsRef={(fn) => { hasErrorsRef.current = fn; }}
                onRecarregarDemanda={atualizaDemandaSilenciosa}
            />
            <AbaAnexos abaAtiva={abaAtiva} demanda={demanda} loading={loading} error={error} acessoNegado={acessoNegado} onRetry={handleRetry} setNAnexos={setNAnexos} highlightedFileId={highlightedFileId} />
            <AbaOrientacoes abaAtiva={abaAtiva} demanda={demanda} onRecarregarDemanda={carregaDemanda} loading={loading} error={error} acessoNegado={acessoNegado} onRetry={handleRetry} onNavigateToFile={handleNavigateToFile} />
            <AbaPendencias
                abaAtiva={abaAtiva}
                id_proposta={id}
                acessoNegado={acessoNegado}
                onPendenciaAtualizada={carregaContadoresPendencias}
                onNavigateToFile={handleNavigateToFile}
            />
            <AbaComentarios
                abaAtiva={abaAtiva}
                id_proposta={id}
                demanda={demanda}
                acessoNegado={acessoNegado}
                onContadorAtualizado={setNComentarios}
            />
            <AbaHistorico 
                abaAtiva={abaAtiva} 
                id={id} 
                loading={loading} 
                onNavigateToFile={handleNavigateToFile}
                fusoHorario={demanda?.data_tz || getFusoHorarioPorComarca(demanda?.uf_comarca || null)}
            />

            <Toaster />

            <ModalDefault
                id={'overlayModal'}
                onClose={fecharOrientacoes}
                openModal={modalOrientations}
                width="100%"
                height="100vh"
                maxWidth="100%"
                maxHeight="100vh"
            >
                <ProfessionalOrientations
                    orientacoes={demanda}
                    close={fecharOrientacoes}
                    finish={() => { setModalOrientations(false); acceptOrientation(); }}
                />
            </ModalDefault>

            <ModalDefault
                id={'overlayModal'}
                onClose={() => setStartTriagemModal(false)}
                openModal={startTriagemModal}
                width="520px"
            >
                <ModalWrapper>
                    <ModalTitle>
                        <div className="points">
                            Deseja iniciar a triagem desta demanda?
                        </div>
                        <div
                            className="close"
                            onClick={() => setStartTriagemModal(false)}
                        >
                            <IconClose />
                        </div>
                    </ModalTitle>

                    <div className="accept">
                        <p>Ao iniciar a triagem, o status da demanda será alterado de Pendente para Em Triagem.</p>
                    </div>

                    <ModalButtons>
                        <ButtonDefault
                            className="cancel"
                            onClick={() => setStartTriagemModal(false)}
                        >
                            Cancelar
                        </ButtonDefault>
                        <ButtonDefault
                            className="continue"
                            onClick={startTriagem}
                        >
                            Confirmar
                        </ButtonDefault>
                    </ModalButtons>

                </ModalWrapper>
            </ModalDefault>

            <ModalDefault
                id={'overlayModal'}
                onClose={() => setEncaminharContratacaoModal(false)}
                openModal={encaminharContratacaoModal}
                width="520px"
            >
                <ModalWrapper>
                    <ModalTitle>
                        <div className="points">
                            Deseja encaminhar esta demanda para contratação?
                        </div>
                        <div
                            className="close"
                            onClick={() => setEncaminharContratacaoModal(false)}
                        >
                            <IconClose />
                        </div>
                    </ModalTitle>

                    <div className="accept">
                        <p>Ao encaminhar para contratação, o status da demanda será alterado de Em Triagem para Em Contratação.</p>
                    </div>

                    <ModalButtons>
                        <ButtonDefault
                            className="cancel"
                            onClick={() => setEncaminharContratacaoModal(false)}
                        >
                            Cancelar
                        </ButtonDefault>
                        <ButtonDefault
                            className="continue"
                            onClick={encaminharParaContratacao}
                            disabled={loading}
                        >
                            {loading ? 'Processando...' : 'Confirmar'}
                        </ButtonDefault>
                    </ModalButtons>

                </ModalWrapper>
            </ModalDefault>

            <ModalDefault
                id={'overlayModal'}
                onClose={() => setAcceptDemandModal(false)}
                openModal={acceptDemandModal}
                width="520px"
            >
                <ModalWrapper>
                    <ModalTitle>
                        <div className="points">
                            Deseja aceitar esta demanda?
                        </div>
                        <div
                            className="close"
                            onClick={() => setAcceptDemandModal(false)}
                        >
                            <IconClose />
                        </div>
                    </ModalTitle>

                    <div className="accept">
                        <p>Ao aceitar a demanda, o status será alterado de Em Contratação para Aguardando Execução e você será o profissional responsável pela execução.</p>
                    </div>

                    <ModalButtons>
                        <ButtonDefault
                            className="cancel"
                            onClick={() => setAcceptDemandModal(false)}
                            disabled={loading}
                        >
                            Cancelar
                        </ButtonDefault>
                        <ButtonDefault
                            className="continue"
                            onClick={aceitarDemanda}
                            disabled={loading}
                        >
                            {loading ? 'Processando...' : 'Confirmar'}
                        </ButtonDefault>
                    </ModalButtons>

                </ModalWrapper>
            </ModalDefault>

            <ModalRecusarDemanda
                modalAtivo={refuseDemandModal}
                setModalAtivo={setRefuseDemandModal}
                onConfirmar={recusarDemanda}
                loading={isRefusing}
            />

            <ModalDefault
                id={'overlayModal'}
                onClose={() => setStartExecucaoModal(false)}
                openModal={startExecucaoModal}
                width="520px"
            >
                <ModalWrapper>
                    <ModalTitle>
                        <div className="points">
                            Confirmar início da demanda?
                        </div>
                        <div
                            className="close"
                            onClick={() => setStartExecucaoModal(false)}
                        >
                            <IconClose />
                        </div>
                    </ModalTitle>

                    <div className="accept">
                        <p>Ao iniciar, o status da demanda será alterado de Aguardando Execução para Em Execução.</p>
                    </div>

                    <ModalButtons>
                        <ButtonDefault
                            className="cancel"
                            onClick={() => setStartExecucaoModal(false)}
                            disabled={loading}
                        >
                            Cancelar
                        </ButtonDefault>
                        <ButtonDefault
                            className="continue"
                            onClick={iniciarExecucao}
                            disabled={loading}
                        >
                            {loading ? 'Processando...' : 'Confirmar'}
                        </ButtonDefault>
                    </ModalButtons>

                </ModalWrapper>
            </ModalDefault>

            <ModalEntregarDemanda
                modalAtivo={entregarModal}
                setModalAtivo={setEntregarModal}
                onConcluir={handleEscolherConcluir}
                onInterromper={handleEscolherInterromper}
            />

            <ModalConcluirDemanda
                modalAtivo={concluirModal}
                setModalAtivo={setConcluirModal}
                onConfirmar={concluirDemanda}
                loading={loading}
                idDemanda={id}
                isAudiencia={demanda?.descricao_categoria_servico === 'Audiências'}
                onVoltar={() => setEntregarModal(true)}
            />

            <ModalInterromperDemanda
                modalAtivo={interromperModal}
                setModalAtivo={setInterromperModal}
                onConfirmar={interromperDemanda}
                loading={loading}
                idDemanda={id}
                onVoltar={() => setEntregarModal(true)}
            />

            <ModalFinalizarDemanda
                modalAtivo={finishDemandModal}
                setModalAtivo={setFinishDemandModal}
                onConfirmar={finalizarDemanda}
                loading={loading}
            />

            <ModalReabrirExecucao
                modalAtivo={reabrirExecucaoModal}
                setModalAtivo={setReabrirExecucaoModal}
                onConfirmar={reabrirExecucao}
                loading={loading}
            />

            <ModalCancelarDemanda
                modalAtivo={cancelarDemandaModal}
                setModalAtivo={setCancelarDemandaModal}
                onConfirmar={cancelarDemanda}
                loading={loading}
            />

            <ModalDefinirPrazoAceite
                open={modalPrazoAceiteOpen}
                onClose={() => setModalPrazoAceiteOpen(false)}
                onConfirm={confirmarPrazoAceite}
                prazoFatal={demanda?.data ? new Date(demanda.data) : undefined}
                prazoConclusao={demanda?.prazo_para_conclusao ? new Date(demanda.prazo_para_conclusao) : undefined}
                timezone={demanda?.data_tz}
                prazoAceiteInicial={demanda?.prazo_aceite}
            />

        </Container>
    )
}